import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Checkbox, Radio, TextField, Paper, FormControlLabel } from "@mui/material";
import Lineinput from "../../../common/lineinput";
import { getCargoReportOtherConfigData, getCargoReportReviewConfigData, cellStyles } from "./Constant";
import { useTranslation } from '../../../../i18n/I18nProvider';
import DropDownOA from "../../../common/dropDownOA";

const renderField = (type, fieldKey, style = {}, setEditSaveData, editSaveData) => {
    const handleChange = (newValue) => {
        setEditSaveData(prev => ({
            ...prev,
            [fieldKey]: newValue
        }));
    };

    const fieldValue = editSaveData?.[fieldKey];

    switch (type) {
        case "checkbox":
            return (
                <Checkbox
                    checked={fieldValue === 1 || fieldValue === true}
                    onChange={(e) => handleChange(e.target.checked ? 1 : 0)}
                    sx={{
                        fontSize: '12px',
                        backgroundColor: 'transparent !important',
                        height: '36px',
                        verticalAlign: 'middle',
                        ...style,
                    }}
                />
            );

        case "radio":
            return (
                <Radio
                    checked={fieldValue === true || fieldValue === 1}
                    onChange={() => handleChange(1)} // assumes selecting this radio sets the value
                    name={fieldKey}
                    sx={{ ...style }}
                />
            );

        case "text":
            return (
                <Lineinput
                    value={fieldValue || ''}
                    onChange={(e) => handleChange(e.target.value)}
                    disabled={fieldKey === 'isDisable'}
                />
            );

        case "DropDown":
            return (
                <DropDownOA
                    value={fieldValue}
                    onSelect={(val) => handleChange(val)}
                    idKey={`id`}
                    dataKey={`name`}
                    noCross={true}
                    minWidth="150px"
                    nextId={'loadBtn'}
                />
            );

        default:
            return null;
    }
};
const CargoReportConfig = (props) => {
    const { setEditSaveData, editSaveData, handleBrnhCargoValue } = props
    const { translations } = useTranslation()
    const mtpl = translations?.mtplMaster || {}
    const cargoReportReveiwConfigData = getCargoReportReviewConfigData(mtpl)
    const cargoReportOtherConfigData = getCargoReportOtherConfigData(mtpl)
    return (
        <>
            <Box sx={{ width: "100%"}}>
                <TableContainer component={Paper} style={{ display: 'flex',overflow:'visible' }}>
                    <Table size="small" style={{ width: '50%', borderRight: '1px solid #d9d9d9' }}>
                        <TableBody>
                            {cargoReportReveiwConfigData.map((section, sectionIdx) => (
                                <React.Fragment key={`section-${sectionIdx}`}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ background: "#DAEDFE", fontWeight: '600', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                            {section.section}
                                        </TableCell>
                                    </TableRow>

                                    {section.rows.map((row, rowIdx) => (
                                        <TableRow key={`row-${sectionIdx}-${rowIdx}`}>
                                            {/* Left Side */}
                                            <TableCell style={{ width: '25%',padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {row.leftLabel}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", ...row.leftStyle, width: "25%" ,padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto'}}>
                                                {renderField(row.leftType, row.leftValue, row.leftStyle, setEditSaveData, editSaveData)}
                                            </TableCell>

                                            {/* Right Side */}
                                            <TableCell sx={{  width: "25%",padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {row.rightLabel}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center", ...row.rightStyle, width: "25%",padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {renderField(row.rightType, row.rightValue, row.rightStyle, setEditSaveData, editSaveData)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                    <Table size="small" style={{ width: '50%' }}>
                        <TableBody>
                            {cargoReportOtherConfigData.map((section, sectionIdx) => (
                                <React.Fragment key={`section-${sectionIdx}`}>
                                    <TableRow>
                                        <TableCell colSpan={6} sx={{ background: "#DAEDFE", fontWeight: '600' ,padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto'}}>
                                            {section.section}
                                        </TableCell>
                                    </TableRow>

                                    {section.rows.map((row, rowIdx) => (
                                        <TableRow key={`row-${sectionIdx}-${rowIdx}`}>
                                            {/* Left Side */}
                                            <TableCell sx={{ ...cellStyles,width:'25%'}}>
                                                {row.leftLabel}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyles,textAlign: "center",width:'25%', ...row.leftStyle,padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {renderField(row.leftType, row.leftValue, row.leftStyle, setEditSaveData, editSaveData)}
                                            </TableCell>
                                            {/* Right Side */}
                                            <TableCell sx={{ ...cellStyles,width:'25%',padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {row.rightLabel}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyles,textAlign: "center",width:'25%', ...row.rightStyle,padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {renderField(row.rightType, row.rightValue, row.rightStyle, setEditSaveData, editSaveData)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}

export default CargoReportConfig